// @flow
import React, { Component } from 'react';
import { SpacerTd, ActionRowTr } from '../../../../components/ModelListStyles';
import { Mobile, Device } from '../../../../components/Responsive';
import {
  DetailedRowDiv,
  DetailedRowP,
  DetailedRowTd,
  DetailedRowH6
} from './MerchantTransactionTableStyles';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import { type Currencies } from '../../../../utilities/types';
import { type Transaction } from '..';
import { formatDate } from '../../../../utilities/misc';
type Props = {
  transaction: Transaction,
  colSpan: number,
  currencies: Currencies
};

export default class MerchantTransactionDetailedRow extends Component<Props> {
  statusColor = () => {
    switch (this.props.transaction.status) {
      case 'overpaid':
        return 'darkOrange';
      case 'underpaid':
        return 'orange';
      case 'paid':
      case 'completed':
      case 'refunded':
        return 'green';
      case 'cancelled':
        return 'red';
      default:
        break;
    }
  };

  render() {
    const { transaction } = this.props;
    let currency = this.props.currencies[transaction.currency];
    if (transaction.settlement_method === 'instant') {
      currency = this.props.currencies[transaction.fiat_currency];
    }
    return (
      <ActionRowTr>
        <SpacerTd />
        <td colSpan={this.props.colSpan}>
          <DetailedRowDiv>
            {/* need to style div */}
            <table>
              <tbody>
                <tr>
                  <td>
                    <DetailedRowH6>ID:</DetailedRowH6>
                  </td>
                  <DetailedRowTd>
                    <DetailedRowP>{transaction.transaction_id}</DetailedRowP>
                  </DetailedRowTd>
                </tr>
                <tr>
                  <td>
                    <DetailedRowH6>DATE:</DetailedRowH6>
                  </td>
                  <DetailedRowTd>
                    <DetailedRowP>
                      {formatDate(transaction.created_at)}
                    </DetailedRowP>
                  </DetailedRowTd>
                </tr>
                <tr>
                  <td>
                    <DetailedRowH6>FEES:</DetailedRowH6>
                  </td>
                  <DetailedRowTd>
                    <DetailedRowP>
                      {formatCurrency(transaction.transaction_fee, currency)}
                    </DetailedRowP>
                  </DetailedRowTd>
                </tr>

                <Device>
                  <tr>
                    <td>
                      <DetailedRowH6>STATUS:</DetailedRowH6>
                    </td>
                    <DetailedRowTd capitalize color={this.statusColor()}>
                      <DetailedRowP>{transaction.status}</DetailedRowP>
                    </DetailedRowTd>
                  </tr>
                </Device>
                <Mobile>
                  <tr>
                    <td>
                      <DetailedRowH6>Commission earned:</DetailedRowH6>
                    </td>
                    <DetailedRowTd>
                      <DetailedRowP>
                        {formatCurrency(
                          transaction.revenue_share || 0,
                          currency
                        )}
                      </DetailedRowP>
                    </DetailedRowTd>
                  </tr>
                </Mobile>
              </tbody>
            </table>
          </DetailedRowDiv>
        </td>
        <SpacerTd />
      </ActionRowTr>
    );
  }
}
